import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ANALYTICS_STORAGE_KEYS } from 'shared/constants';

const isBrowser = typeof window !== 'undefined';

let visitorId = null;
let initPromise = null;

const generateFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    visitorId = result.visitorId;
    localStorage.setItem(ANALYTICS_STORAGE_KEYS.DEVICE_ID, visitorId);
    console.debug('[DeviceFingerprint] Generated new device ID:', visitorId);

    return visitorId;
  } catch (error) {
    console.error('[DeviceFingerprint] Error:', error);
    return null;
  }
};

const initialize = async () => {
  if (!isBrowser) return null;

  const cachedId = localStorage.getItem(ANALYTICS_STORAGE_KEYS.DEVICE_ID);
  if (cachedId) {
    visitorId = cachedId;
    console.debug('[DeviceFingerprint] Using cached device ID:', visitorId);
    return visitorId;
  }

  return generateFingerprint();
};

export const getDeviceId = async () => {
  if (visitorId) return visitorId;
  if (!initPromise) {
    initPromise = initialize();
  }
  return initPromise;
};
